/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDoctorDetails } from 'app/shared/model/doctor-details.model';
import { IUser } from 'app/shared/model/user.model';
import { ISaluation } from 'app/shared/model/saluation.model';

export interface IDoctor {
  id?: string;
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
  fullName?: string;
  createdDtm?: number | null;
  createdBy?: string | null;
  modifiedBy?: string | null;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  cursor?: number;
  active?: boolean;
  status?: boolean;
  acceptAppointments?: boolean | null;
  acceptNewPatients?: boolean | null;
  doctorDetails?: IDoctorDetails | null;
  tmUser?: IUser;
  saluationId?: ISaluation;
}

export const defaultValue: Readonly<IDoctor> = {
  active: false,
  status: false,
  acceptAppointments: false,
  acceptNewPatients: false,
};
